import Guid from '@/app/utils/guid'

export default class Match {

  public id = Guid.empty()
  public name = ''
  public keywords: string[] = []
  public stakeholderId = Guid.empty()
  public role = ''
  public region = ''
}
